export const ROUTE_TO_HOME_PAGE = '/';
export const ROUTE_TO_COLLECTION_PAGE = '/collection';
export const ROUTE_TO_TOKEN_PAGE = '/token';
export const ROUTE_TO_ABOUT_PAGE = '/about';
export const ROUTE_TO_WARNING_PAGE = '/warning';
export const ROUTE_TO_RESERVATION_PAGE = '/reservation';
export const ROUTE_TO_RESERVED_MINT_PAGE = '/reserved-mint';
